import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { ConfigService } from '../services/config.service';

export class CmxTranslateLoader implements TranslateLoader {
  private translateHost: string;
  private translateUrl: string;
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
  ) {
    const config = this.configService.getConfig();
    this.translateHost = config.translate.translateHost;
    this.translateUrl = config.translate.translateUrl;
  }

  // TODO change app name
  getTranslation(lang: string) {
    return this.http.get(`${this.translateHost}${this.translateUrl}ordersnproduct/${lang}`);
  }
}
